








import { Component, Prop, Watch, Vue } from "vue-property-decorator";

@Component
export default class ReviewVideo extends Vue {
  @Prop() private url!: string;
  @Prop() private isVideoPlaying!: boolean;
  @Prop() private onCurrentTime!: number;
  @Prop() private playsegment?: number[];
  @Prop({ default: 1 }) private playbackRate!: number;
  private video?: HTMLVideoElement;
  private isPlayFromSegment:boolean = false;

  private mounted() {
    this.setupVideo();
  }

  private setupVideo() {
    this.video = this.$refs.video as HTMLVideoElement;
    const video = this.video!;
    video.playbackRate = this.playbackRate;

    video.onloadeddata = () => {
      let isPortrait = false;
      if (video.videoWidth < video.videoHeight) {
        isPortrait = true;
      }
      this.$emit("onOrientation", isPortrait);
      this.$emit("onDuration", video.duration);
    };

    video.ontimeupdate = () => {
      let perc = video.currentTime / video.duration;
      perc = perc * 100;
      this.$emit("onProgress", perc);
      if(this.isPlayFromSegment && this.playSegment && this.playsegment!.length > 1 && video.currentTime > this.playsegment![1] && this.isVideoPlaying){
        this.isPlayFromSegment = false;
        this.$emit("isVideoPlaying", false);
      }
    };
  }
  @Watch("url")
  private onUrlChanged() {
    this.setupVideo();
  }

  @Watch("isVideoPlaying")
  private onVideoPlaying() {
    if (this.isVideoPlaying) {
      if (this.video) this.video.play();
    } else {
      if (this.video) this.video.pause();
    }
  }

  @Watch("onCurrentTime")
  private onCurrentTimeChange() {
    if (this.video) this.video.currentTime = this.onCurrentTime;
  }

  @Watch("playsegment")
  private playSegment() {
    
    if (!this.playsegment || this.playsegment!.length < 1) {
      return;
    }
    const start = this.playsegment![0];
    const end = this.playsegment![1];
    if(this.video) {
      this.video.currentTime = start;
      this.isPlayFromSegment = true;
      if (!this.isVideoPlaying) {
        this.$emit("isVideoPlaying", true);
      }
    }
  }

  @Watch("playbackRate")
  private onPlaybackRateChanged() {
    if (this.video) {
      this.video.playbackRate = this.playbackRate;
    }
  }
}
